function buocQuanLySot() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Quản lý Sọt + in tem QR",
      content:
        "Nhân viên KHÔNG tự tạo Sọt ngoài hiện trường — chỉ Admin cấp Sọt và in QR ở trang này. Hết tem mà chưa chuẩn bị trước ca sẽ chặn cả đội thu mua, nên đây là bước chuẩn bị quan trọng cần làm trước mỗi ca.",
    },
    {
      target: "#tour-quan-ly-sot-tao-moi",
      title: "Bước 2 · Tạo Sọt mới",
      content:
        "Nhập Số lượng Sọt để tạo hàng loạt tem trống cùng lúc. Khối lượng chứa tối đa (kg) là bắt buộc — Form thu mua dùng số này để cảnh báo khi Sọt gần đầy. Khối lượng bì (kg) không bắt buộc, chỉ dùng để trừ bì khi cân kho.",
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-sot-bang",
      title: "Bước 3 · Chọn nhiều để in QR hàng loạt",
      content:
        "Tick vào ô chọn ở đầu mỗi dòng Sọt để chọn nhiều — một thanh công cụ hiện phía trên bảng cho phép tải/in QR hàng loạt (có thể chỉnh kích thước QR cm ngay tại đó) hoặc sửa hàng loạt nhiều Sọt cùng lúc.",
      placement: "top",
    },
  ];
}

export default buocQuanLySot;
